import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GuestManagement = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Immediate redirect to gift registry creation as per navigation rule
    navigate('/create', { replace: true });
  }, [navigate]);

  // This component will never render as it immediately redirects
  return null;
};

export default GuestManagement;